import React, { Component } from 'react';
import Config from './Config';
import List from './List';
import SearchBox from './SearchBox';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/Dispatch.css';
import FX from './functions/functions';
import Modal from './Modal';
import SweetAlert from 'sweetalert2-react';
import AddressEditor from './AddressEditor';
import AddressViewer from './AddressViewer';
import ConsignmentViewer from './ConsignmentViewer';
import ContextMenu from './ContextMenu';
import Calendar from './Calendar';
//import OrderEdge from './OrderEdge';

class Dispatch extends Component {
  constructor(props) {
    super(props);
    this.state = { activeProduct: null, showSide: true, context: {show:false}, page: 0  };
    this.props.root.autoKey = (e) => {
      if(this.props.root.state.detail){
          if(e.target.tagName === 'BODY'){
              //document.getElementById('item_search').value = '';
              //document.getElementById('item_search').focus();
          }
          if(e.key === 'Enter'){
              console.log(e.target.id.split("_")[0]);
              console.log(this.enterAction);
              if(typeof this.enterAction[e.target.id.split("_")[0]] === 'function'){
                 this.enterAction[e.target.id.split("_")[0]](e);
              }
          }
      }
      else{
        console.log(e);
      }
      console.log('xxx');
        console.log(e);
    }
  }
  setPage = page => {
    console.log(this.state.page);
    console.log(page);
    if(page.action === '+1'){
      page.action = this.state.page + 1;
    }
    else if(page.action === '-1'){
      page.action = this.state.page -1;
    }
    console.log(page);
    this.retrieveData(30, page.action);
  }
  retrieveData = (limit, page) => {
    if(isNaN(limit)){
      limit = 30;
      if(parseInt(this.props.root.state.current_customer.dispatches.limit,10)){
        console.log(limit = parseInt(limit,10) + parseInt(this.props.root.state.current_customer.dispatches.limit,10));
      }
    }
    if(isNaN(page)){
      page = 0;
    }
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {customer_id: this.props.root.state.customer_id, sort: sort_str, limit: limit, page: page};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'dispatch_paged' + qs , (res, i) => {
      var currCust = this.props.root.state.current_customer;
      currCust.dispatches.list = res.dispatches;
      currCust.dispatches.count = res.count;
      currCust.dispatches.limit = res.limit;
      currCust.dispatches.pages = res.pages;
      currCust.dispatches.page = res.page;
      this.setState({page: res.page});
      currCust.dispatches.data = data;
      currCust.dispatches.path = 'dispatch_paged';
      this.props.root.setState({ current_customer : currCust  });
      this.props.root.loadNextPage =  this.retrieveData;
    });
  }
  componentDidMount(){
    this.loadDetail();
    console.log('oooo');
    this.retrieveData(30);
  }
  showCalendar = (tgt, e) => {
    var detail = this.props.root.state.detail;
    console.log(e);
    console.log(e.type);
    console.log([e.clientX,e.clientY]);
    var loc;
    if(e.type === 'focus'){
      loc = e.target.getBoundingClientRect();
      console.log(loc);
      loc = [loc.left,loc.bottom];
    }
    else {
      loc =  [e.clientX,e.clientY];
    }
    console.log(loc);
    if(tgt === 'release_date' || tgt === 'expiry'){
        this.setState({showCalendar: {location: loc, target: tgt}});
    }
  }
  toggleDrawer = () => {
    var drawerState = (this.state.drawerState === 'open') ? undefined : 'open';
    this.setState({drawerState : drawerState});
    console.log(drawerState);
  }
  enterAction = {
    'recBox': (e)=> {
      console.log(e.key);
      e.target.blur();
      this.closeProductModal();
    },
    'activeProductQty' : (e) => {
      console.log(e.key);
      e.target.blur();
      this.addActiveItem();
    }
  }
  componentDidUpdate(prevprops, prevstate){
    FX.doFocus(this);
    console.log(prevstate);
    console.log(prevprops);
    console.log(this.props.root.state.detail);
    console.log(prevprops.root.state.detail);
    console.log(this.loading);
    var k = parseInt( this.props.root.state.detail , 10 );
    if( !this.loading && typeof this.props.root.state.detail === 'number'  ){
       this.loading = true;
       console.log(this.props.root.state.detail);
       this.retrieveDetail(this.props.root.state.detail);
    }
  }
  loadDetail(){
    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    var found = false;
    /*if(x[1] && parseInt(x[1],10)){
        console.log(parseInt(x[1],10));
        var root_state = this.props.root.state;
        this.props.root.state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            root_state.detail = ping;
            return found = true;
          }
          return false;
        }
        );
     }*/
      if (x[1] && !found) {
        this.retrieveDetail(parseInt(x[1],10));
        //console.log('/' + x[0]);
        //FX.navigate.bind(this,state.panel, undefined ,'/' + x[0],state,true)();
        //window.location = '/' + x[0];
      }
  }
  dispatchUncheck = (obj) => {
    var d = document.querySelectorAll('#dispatches .lineSelect:checked');
    d.forEach(_d => {
        _d.checked = false;
    });
  }
  dispatchCheck = (obj) => {
    var d = document.querySelectorAll('#dispatches .lineSelect:checked');
    var out = [];
    d.forEach(_d => {
        this.props.root.state.current_customer.dispatches.list.some(disp => {
            if(disp.id == _d.dataset.obj_id){
               out.unshift(disp);
              return true;
            }
            return false;
        })
    });
    this.setState({checked: out});
    return out;
  }
  mergeDispatches = () => {
    var merge = this.dispatchCheck();
    this.setState({mergeConfirm: true});
  }
  merge = () => {
    FX.load(this.props.root,'dispatch/merge' , (res, i) => {
      console.log(res);
      if(res.success){
          console.log('mlkmlk');
          FX.navigate.bind(this.props.root, this.props.root.state.panel, res.show ,'/dispatches/'+res.show)();
          this.closeModal();
      }
      else {
          var msg = 'These orders cannot be merged:';
          res.stop.forEach( stop => {
              msg += '\n ' + stop.reference + ' ' + stop.statusName;
          });
          window.confirm(msg);
      }
    }, {method:'POST',data:{merge : this.state.checked, mergeTo: document.getElementById('mergeTo').value}});
  }
  retrieveDetail = (id) => {
    console.log('pop');
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {id: id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'dispatch_detail' + qs , (res, i) => {
      this.props.root.setState({detail: res.dispatch});
      this.loading = false;
      if(res.dispatch && Array.isArray(res.dispatch.dispatch_items)){
        // Seed synchronously from the embedded line products so by-id lookups
        // resolve immediately (no race against the async hydrate), then top up.
        FX.cacheProducts(this.props.root, res.dispatch.dispatch_items.map(di => di.product).filter(Boolean));
        FX.hydrateProducts(this.props.root, res.dispatch.dispatch_items.map(di => di.product_id));
      }
    });
  }
  showList = () => {
    FX.navigate.bind(this.props.root,this.props.root.state.panel, undefined ,'/dispatch')();
  }
  showPackingStation = () => {
    var panelData = this.props.root.state.panelData;
    panelData.packingStation.dispatch_id = this.props.root.state.detail.id;
    this.props.root.setState({panelData:panelData});
    FX.navigate.bind(this.props.root,'packing_station', undefined ,'/packingStation')();
  }
  checkChecked = () => {
    var d = document.querySelectorAll('.product_check:checked');
    var selected = [];
    for (var i = 0; i < d.length; i++){
      selected.push(parseInt(d[i].dataset.dispatch_item_id,10));
    }
    console.log(selected);
    return selected;
  }
  unCheck = (di_id) => {
    var d = document.querySelectorAll('.product_check:checked');
    for (var i = 0; i < d.length; i++){
      if(di_id == parseInt(d[i].dataset.dispatch_item_id,10)){
        console.log(d[i].checked)
        d[i].checked = false;
        console.log(d[i].checked)
        this.forceUpdate();
      }
    }

  }
  moveToNew = (_do_) => {
    var selected = this.checkChecked();
    if(selected.length === 0){
      return alert('Nothing selected');
    }
    var dispatch_items = this.props.root.state.detail.dispatch_items;
    if(selected.length === dispatch_items.length){
      return alert('This will empty the current dispatch');
    }
    var movingQ = '';
    dispatch_items.forEach(di => {
      console.log(di);
      console.log(di.product.name);
      console.log(selected.indexOf(di.id));
      if(selected.indexOf(di.id) !== -1 && di.quantity > 1){
        movingQ ? movingQ += ' ' : '';
        movingQ += di.product.name
      }
    })
    if(!this.state.moveToNewDispatch){
        return this.setState({moveToNewDispatch: true});
    }
    console.log('pepor');
    var dispatch_ref;
    if(document.getElementById('new_dispatch_ref')){
        dispatch_ref = document.getElementById('new_dispatch_ref').value;
    }
    console.log({ dispatch_ref: dispatch_ref, moveTo:document.getElementById('moveTo'), order_id: this.props.root.state.detail.order_id, dispatch_items: selected});
    //return 'xxx';
    var moveTo;
    if(document.getElementById('moveTo') && document.getElementById('moveTo').value){
      moveTo = document.getElementById('moveTo').value;
    }
    else {
      moveTo = null;

    }


    FX.load(this.props.root,'moveToNewDispatch' , (res, i) => {
          console.log(res);
          console.log(res.success);
          if(res.success){
             console.log(res);
          }
    }, {method:'POST',data:{ dispatch_ref: dispatch_ref,  moveTo: moveTo, order_id: this.props.root.state.detail.order_id, dispatch_items: selected}});
  }

  notifyReturn = () => {
    var selected = this.checkChecked();
    console.log(selected);
    FX.load(this.props.root,'notifyReturn' , (res, i) => {
          console.log(res);
          console.log(res.success);
          if(res.success){
             console.log(res);
          }
          FX.navigate.bind(this.props.root,'deliveries', undefined ,'/deliveries/' + res.delivery_id)();
    }, {method:'POST',data:{ dispatch_id: this.props.root.state.detail.id, dispatch_items: selected}});
  }
  selectProduct = (prod) => {
    FX.cacheProducts(this.props.root, [prod]);   // keep the picked product resolvable by id
    this.setState({activeProduct : prod})
    this.focusTgt = 'activeProductQty';
  }
  addActiveItem = () => {
    var found = false;
    var dispatch_items = this.props.root.state.detail.dispatch_items;
    var activeProduct = this.state.activeProduct;
    dispatch_items.some( (di, i) => {
        console.log(this.state.activeProduct.id);
        console.log(di);
        if(this.state.activeProduct.id == di.product_id){
          di.quantity += parseInt(document.getElementById('activeProductQty').value, 10);
          found = true;
        }
        return found;
    });
    if (!found) {
      console.log(this.state.activeProduct.name);
      dispatch_items.push({
        id:-1,
        product: activeProduct,
        product_id: activeProduct.id,
        quantity: parseInt(document.getElementById('activeProductQty').value, 10)
      })
    }
    this.setState({dispatch_items : dispatch_items, activeProduct: null});
    this.focusTgt = 'prod_search';
  }
  removeItem = (prod) => {
    console.log(prod);
    if(!window.confirm('Are you sure you wish to remove this item.')){
      return false;
    }
    var dispatch_items = this.props.root.state.detail.dispatch_items;
    dispatch_items.some( (di, i) => {
        if(prod == di.product_id){
          dispatch_items.splice(i,1);
          return true;
        }
        return false;
    });
    this.props.root.setState({dispatch_items : dispatch_items});
  }

  contextHide = () => {
    this.setState({context: false});
  }
  contextShow = (di, e) => {
    var options = [{title: "View Product",action:()=>{FX.navigate.bind(this.props.root, 'products'  , undefined ,'/products/'+di.product_id)() }}]
    this.setState({context : {show: true, location: [e.clientX,e.clientY], options: options}});
  }
  editAddress = (tgt) => {
    this.setState({editAddress: tgt});
  }
  closeModal = () => {
    this.setState({editAddress:undefined,moveToNewDispatch:undefined,mergeConfirm:false});
  }
  setAddress = (data, target) => {
    console.log(target, data);
    if(target){
      this.props.root.changed = true;
      var detail = this.props.root.state.detail;
      var targets = ['delivery_address'];
      if(detail[target]){
        var add_id = detail[target].id;
        targets.forEach((tgt, i) => {
            if(add_id !== -1 && add_id == detail[tgt].id && tgt !== target){
                detail[tgt] = data;
            }
        })
      }
      detail[target] = data;
      this.props.root.setState({detail:detail});
    }
    this.closeModal();
  }
  save = () => {
    var detail = this.props.root.state.detail;
    if(!detail.dispatch_items.length){
      alert('Please add products before saving order');
        this.focusTgt = 'prod_search';
        this.forceUpdate();
        return false;
    }
    if(parseInt(detail.post_service_id) <= 0){
      alert("Please select a shipping service.");
      this.focusTgt = 'service_select';
      this.forceUpdate();
      return false;
    }
    if(!FX.validateAddress(detail.delivery_address) && parseInt(detail.post_service_id) !== 17){
      FX.validateAddress();
      window.confirm("Please enter a delivery address.");
      return false;
    }
    console.log(this.props.root.state.detail);
    var detail = this.props.root.state.detail;
    FX.load(this.props.root,'dispatch/save' , (res, i) => {
          console.log(res);
          console.log(res.success);
          if(!res.error){
             console.log(res);
             this.props.root.setState({detail : res.dispatch});
          }
          else {
             alert(res.error_text);
          }
          this.props.root.changed = false;
    }, {method:'POST',data:{detail : detail}});
  }
  addOutstanding = (outstanding) => {
    var found = false;
    var pro;
    var dispatch_items = this.props.root.state.detail.dispatch_items;
    this.props.root.state.current_customer.products.list.some(prod => {
      if(prod.id == outstanding.product_id){
        pro = prod;
        return true;
      }
      return false;
    });
    if(!pro){
      // The outstanding row embeds sku/name; build a product with the stock
      // fields the dispatch-line renderer dereferences (it does
      // di.product.stock.toString()), so a non-resident outstanding product
      // doesn't crash the render.
      pro = {id: outstanding.product_id, product_id: outstanding.product_id, sku: outstanding.sku, name: outstanding.name,
             stock: 0, stock_alloc: 0, stock_pre_order: 0, stock_exp: 0, barcode: '', locations: []};
    }
    dispatch_items.some( (di, i) => {
        //console.log(pro.id);
        console.log(di);
        if(pro.id == di.product_id){
          di.quantity += outstanding.outstanding;
          di.warn_correct = true;
          found = true;
        }
        return found;
    });
    if (!found) {
      dispatch_items.push({
        id:-1,
        product: pro,
        product_id: pro.id,
        quantity: outstanding.outstanding,
        warn_correct: true
      })
    }
    this.setState({dispatch_items : dispatch_items, activeProduct: null});


  }
  cancel = ( action ) => {
    var detail = this.props.root.state.detail;
    if(!this.state.cancelPrompt){
        if(this.isAdmin()){
            console.log('cancel');
        }
        else {
            this.setState({cancelPrompt:{reason: ''}});
        }
    }
    else {
        if(action === true){
            FX.load(this.props.root,'dispatch/cancelRequest' , (res, i) => {
                this.setState({cancelPrompt:false});
            }, {method:'POST',data:{dispatch_id:detail.id, reason: this.state.cancelPrompt.reason}});
        }
        else {
            this.setState({cancelPrompt:false});
        }
    }
  }
  handler = (tgt, e) => {
    this.props.root.changed = true;
    if(tgt == 'this.cancel'){
        this.state.cancelPrompt.reason = e.target.value;
        this.setState({cancelPrompt: this.state.cancelPrompt})
    }
    var detail = this.props.root.state.detail;
    detail[tgt] = e.target.value;
    this.props.root.setState({detail:detail});
  }
  toggle = (tgt, e) => {
    this.props.root.changed = true;
    var detail = this.props.root.state.detail;
    detail[tgt] = !detail[tgt];
    this.props.root.setState({detail:detail});
  }
  reRender = () => {
    this.forceUpdate();
  }
  setPriority = () => {
    console.log('xxx');
    this.props.root.changed = true;
    var detail = this.props.root.state.detail;
    if (!detail.priority){
      detail.priority = 20;
    }
    else{
      detail.priority = 0;
    }
    this.props.root.setState({detail:detail});

  }
  isAdmin = () => {
    var user = this.props.root.state.user;
    return parseInt(user.admin_level, 10);
  }
  isEditable = () => {
    var editable = 0;
    var detail = this.props.root.state.detail;
    if (detail.dispatch_status < 10){
        editable = 1;
    }
    if (detail.dispatch_status < 50 && this.isAdmin()){
        editable = 1;
    }
    return editable;
  }
  backAction = () => {
      if(!this.isAdmin()){
        FX.navigate.bind(this.props.root, 'orders'  , this.props.root.state.detail.order_id ,'/orders/'+this.props.root.state.detail.order_id)()
      }
      else {
          this.showList();
      }
  }
  nextSibling = () => {
      return 'Test';
  }
  toggleSide = () => {
    this.setState({showSide:!this.state.showSide});
  }
  render() {
    var detail = this.props.root.state.detail;
    var isAdmin = this.isAdmin();
    console.log(this.props.root.state.detail)
    if(detail && typeof detail !== 'number' ){
      if(detail.dispatch_items === undefined){
        detail.dispatch_items = [];
      }
      var dispatch_headers;

      var dispatch_items = detail.dispatch_items.map(di =>{
        var removeBtn;
        if(this.isEditable()){
             removeBtn = <i onClick={this.removeItem.bind(this, di.product_id)} className="material-icons product_remove">close</i>
        }
        if ( detail.dispatch_status < 10 && detail.dispatch_status >= 0){
            var stock = di.product.stock.toString();

            var title;

            if(parseInt(di.product.stock_alloc, 10)){
              stock += " (" + (di.product.stock - di.product.stock_alloc).toString() + ")";
              title = 'Brackets represent stock on hand (after fulfilling all outstanding and unpacked orders)';
            }
            var lineClass = '';
            var barcode;
            if(di.product.barcode){
              barcode = (<span className="product_barcode">{di.product.barcode}</span>)
            }
            if ((di.product.stock-di.product.stock_alloc) < 0){
              lineClass = 'unfulfilable';
            }
            console.log((di.product.stock-di.product.stock_alloc))


            dispatch_headers = (
              <tr className="header">
                <th></th>
                <th>Product</th>
                <th>Stock (Available)</th>
                <th>Qty</th>
                <th></th>
              </tr>
            );


            return (
              <tr className={lineClass}>
                <td><input type="checkbox" className="product_check" onClick={this.reRender} data-dispatch_item_id={di.id}/></td>
                <td>
                  <span className="product_name">{di.product.name}</span>
                  <span className="product_sku">{di.product.sku}</span>
                  {barcode}
                </td>
                <td className="product_stock"  title={title}>{stock}</td>
                <td className="product_quantity">{di.quantity}</td>
                <td>
                  <span className="product_menu" onClick={this.contextShow.bind(this,di)}><i className="fa fa-ellipsis-v" /></span>
                  {removeBtn}
                </td>
              </tr>
            );
        }
        else {
            var barcode;
            if(di.product.barcode){
              barcode = (<span className="product_barcode">{di.product.barcode}</span>)
            }
            dispatch_headers = (
              <tr className="header">
                <th></th>
                <th>Product</th>
                <th>Qty</th>
                <th></th>
              </tr>
            );

            return (
              <tr>
                <td><input type="checkbox" className="product_check" onClick={this.reRender} data-dispatch_item_id={di.id}/></td>
                <td>
                  <span className="product_name">{di.product.name}</span>
                  <span className="product_sku">{di.product.sku}</span>
                  {barcode}
                </td>
                <td className="product_quantity" >{di.quantity}</td>
                <td>
                  <span className="product_menu" onClick={this.contextShow.bind(this,di)}><i className="fa fa-ellipsis-v" /></span>
                  {removeBtn}
                </td>
              </tr>
            );
        }
      })
      var active;
      if (this.state.activeProduct){
        active = (
          <div className="activeProduct">{this.state.activeProduct.sku} - {this.state.activeProduct.name} <input id="activeProductQty"  onFocus={(e) => {this.props.root.autoKey = this.autoKey;}} /><button onClick={this.addActiveItem} ><i className="material-icons">add</i></button></div>
        );
      }
      var editAddress;
      if(this.state.editAddress){
        /*editAddress = (
        <Modal fs={true} title={FX.ucfirst(this.state.editAddress) + " Address"} close={this.closeModal} >
            <AddressEditor  fs={true} root={this.props.root} varTgt={this.state.editAddress + "_address"} />
        </Modal>
        )
        */
        editAddress = (
           <AddressEditor root={this.props.root} title={this.state.editAddress} varTgt={this.state.editAddress + "_address"}  hideAddress={this.setAddress} />
        )
      }
      var moveToNewDispatch;
      if(this.state.moveToNewDispatch){
          var movingQ = [];
          var dis = detail.dispatch_items;
          var siblings = detail.siblings;
          var selSib = siblings.map(sib=>{
            if(sib.dispatch.id == detail.id){
              return null;
            }
            return <option value={sib.dispatch.id}>{sib.dispatch.reference}</option>
          });
          if (detail.siblings.length > 1 && this.state.moveEx){
            selSib = (
                <div className="selectSiblings">
                    <div>
                        <select id="moveTo">
                            <option value="">----</option>
                            {selSib}
                        </select>
                    </div>
                    <div>
                        <div className="moveNew_btn" onClick={() => {this.setState({moveEx : false})}}>Move to New Dispatch</div>
                    </div>
                </div>)
          }
          else {
            selSib =  (
              <div className="selectSiblings">
                  <div>
                    <label>New Dispatch Reference</label>
                    <input id="new_dispatch_ref" defaultValue={this.nextSibling} />
                  </div>
                    <div>
                      <div className="moveExisting_btn" onClick={() => {this.setState({moveEx : true})}}>Move to Existing Dispatch</div>
                  </div>
              </div>)
          }
            var selected = this.checkChecked();
            dis.forEach((di,i) => {
            console.log(di);
            console.log(di.product.name);
            console.log(selected.indexOf(di.id));
            if(selected.indexOf(di.id) !== -1 && di.quantity > 1){
              movingQ.push(<tr key={'nn_' + i}><td>{di.product.name}</td><td style={{textAlign:'right'}}><input data-max={di.quantity} defaultValue={di.quantity} onChange={FX.limit} className="numField" /></td><td onClick={this.unCheck.bind(this,di.id)}><i className="material-icons">close</i></td></tr>)
            }
            else if(selected.indexOf(di.id) !== -1){
              movingQ.push(<tr key={'nn_' + i}><td>{di.product.name}</td><td></td><td onClick={this.unCheck.bind(this,di.id)}><i className="material-icons">close</i></td></tr>)
            }
          })

          moveToNewDispatch = (
            <Modal  buttons={[{text:'Cancel',action:this.closeModal},{text:'OK',action:this.moveToNew}]}  fs={true} title={"Move Items"} close={this.closeModal} >
              <div className="moveItems">
             {selSib}
              <table className="movingItems" >
               {movingQ}
              </table>
              </div>
            </Modal>
          )
      }
      var warn;
      if(detail.warn){
        var _w = [];
        warn = detail.warn.map(w => {
          console.log(_w)
          if(_w.indexOf(w.outstanding.sku) > -1){
            return null;
          }
          _w.push(w.outstanding.sku);
          var className;
          if(w.outstanding.outstanding > 0){
            className = 'under'
          }
          else if (w.outstanding.outstanding < 0){
            className = 'over'

          }
          var found = false;
          var _di;
          detail.dispatch_items.some(di => {
              if(di.product_id == w.outstanding.product_id || di.product_id == w.outstanding.product_id){
                _di = di;
                return found = true;
              }
              return found;
          });
          if((found && w.outstanding.outstanding < 0) ){
            return <div className={className} oversupplied >{w.outstanding.sku} -{w.outstanding.name}: Outstanding: {w.outstanding.outstanding} </div>
          }
          else if((!found || !_di.warn_correct) && w.outstanding.outstanding > 0){
            return <div className={className} oversupplied >{w.outstanding.sku} -{w.outstanding.name}: Outstanding: {w.outstanding.outstanding} <button onClick={this.addOutstanding.bind(this, w.outstanding)}>Add</button></div>
          }
          return null;
        })
      }
      (
         <div>
            <ul>
            <li> -- Check Stock before accepting</li>
            <li>Log CHanges</li>
            <li>Prevent Echos: --> PackingStation</li>
            <li>Allow admin override for windbacks</li>
            <li>Auto stock rewind on >=packed -> \&lt;=picking</li>
            </ul>
            &pound;
          </div>
      )
      var dispatch_date;
      if(detail.dispatch_date){
         dispatch_date = (<div className="dispatch_date">
              Dispatch date: {FX.dateFormat(this.props.root.state.detail.dispatch_date)}
              </div>)
      }

      var sideButtons;
      var backAction;
      if (!this.isEditable()) {
        sideButtons = (
            <div id="sideButtons">
              <button onClick={this.backAction}>Back</button>
              </div>
        )
      }
      else {
        sideButtons = (
            <div id="sideButtons">
              <button onClick={this.backAction}>Back</button>
              <button onClick={this.save}>Save</button>
            </div>
        )
      }

      var admin_controls = [];
      if (isAdmin && detail.dispatch_status >= 10 && detail.dispatch_status < 30 ) {
          admin_controls.push(<button onClick={this.showPackingStation}>
            Pack Dispatch
          </button>);
      }
      if (isAdmin && detail.dispatch_status >= 10 ) {
          admin_controls.push(<a target="_blank" href={"http://api.vdepot.co.uk/docs/picking.php?id=" + detail.id} className="button">
            Reprint Dispatch Note
          </a>);
      }
      if (detail.dispatch_status >= 30 ) {
          admin_controls.push(<a target="_blank" href={"http://api.vdepot.co.uk/consignment/?id=" + detail.id} className="button">
            Manage Consignment
          </a>);
      }
      admin_controls = (<div className="admin_controls">{admin_controls}</div>)
      var ps_set = [];
      var post_services;
      var post_services_x = [{id:-1, name: '--------', client_selectable: 1}].concat( this.props.root.state.utilities.post_services).map(ps => {
        if(ps.client_selectable == 1 && !ps_set.includes(parseInt(ps.id,10))){
            ps_set.push(parseInt(ps.id,10));
            return (<option value={parseInt(ps.id,10)} >{ps.name}</option>)
        }
      });





      if(this.isEditable()){
        var ps_set = [];
        var post_services_x = [{id:-1, name: '--------', client_selectable: 1}].concat( this.props.root.state.utilities.post_services).map(ps => {
          if(ps.client_selectable == 1 && !ps_set.includes(parseInt(ps.id,10))){
              ps_set.push(parseInt(ps.id,10));
              return (<option value={parseInt(ps.id,10)} >{ps.name}</option>)
          }
        });

         post_services = (<select className="service_select" id="service_select" value={parseInt(this.props.root.state.detail.post_service_id,10)} onChange={this.handler.bind(this, 'post_service_id')}>
                    {post_services_x}
                  </select>)
      }
      else {
        this.props.root.state.utilities.post_services.some(ps => {
          if(parseInt(ps.id,10) === parseInt(this.props.root.state.detail.post_service_id,10)){
            post_services = <div className="postService">{ps.name}</div>
            return true;
          }
          return false;

        })
      }







      var calendar;
        console.log(this);
      if (this.state.showCalendar && this.state.showCalendar.target === 'release_date'){
        console.log('test');
        calendar = (
            <ContextMenu show={true} location={this.state.showCalendar.location} contextHide={() =>{ this.setState({showCalendar: undefined}); console.log(this);}} parent={this}>
                <Calendar date={detail.release_date} close={(date) => { if (date) { this.props.root.changed = true; }; detail.release_date = FX.dateFormat(date,'php'); this.props.root.setState({detail:detail}); this.setState({showCalendar:false})}} range={false} />
            </ContextMenu>
        )
      }
      var release_date;
      if(detail.release_date && FX.dateFormat(detail.release_date,'{U}') > FX.dateFormat(new Date,'{U}')){
          release_date =  (<div className="release_date" onClick={this.showCalendar.bind(this,'release_date')}>
              Release Date: {FX.dateFormat(detail.release_date,'{d2}/{m2}/{Y}')}
            </div>)

            var sched = (<div className="modbtn delay_btn waiting" title="Delay Dispatch" title="Hold Dispatch - the dispatch will be held until the specified date." onClick={this.showCalendar.bind(this,'release_date')}>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </div>);

      }
      else if(detail.release_date && FX.dateFormat(detail.release_date,'{U}') <= FX.dateFormat(new Date,'{U}')){
            var sched = (<div className="modbtn delay_btn go" title="Delay Dispatch" title="Hold Dispatch - the dispatch will be held until the specified date." onClick={this.showCalendar.bind(this,'release_date')}>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </div>);

      }
      else if(false && this.isEditable()) {
         release_date = (<div onClick={this.showCalendar.bind(this,'release_date')} className="delayDispatch">Delay Dispatch</div>)

            var sched = (<div className="modbtn delay_btn" title="Delay Dispatch" title="Hold Dispatch - the dispatch will be held until the specified date." onClick={this.showCalendar.bind(this,'release_date')}>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </div>);

      }
      else if(this.isEditable()) {
            var sched = (<div className="modbtn delay_btn" title="Delay Dispatch" title="Hold Dispatch - the dispatch will be held until the specified date." onClick={this.showCalendar.bind(this,'release_date')}>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </div>);
      }
      var prioritise;
      if(parseInt(detail.priority,0)){
          prioritise = (<div className="modbtn prioritised" title="Deprioritise Dispatch - When stock becomes available, will be handled chronologically." onClick={this.setPriority}>
              <i className="fa fa-forward" aria-hidden="true" />
            </div>)
      }
      else {
         prioritise = (<div className="modbtn prioritise" title="Prioritise Dispatch - When stock becomes available, we'll try to prioritise this order." onClick={this.setPriority}>
              <i className="fa fa-forward" aria-hidden="true" />
              </div>)
      }
      if( 0 && parseInt(this.state.setPriority,0)){
          prioritise = (
              <Modal close={this.closeModal} buttons={[{text:'Merge',action:this.merge}]}>

              </Modal>
          )
      }
      var draft;
      if(parseInt(detail.draft,0) || detail.draft ? 1 : 0){
          draft = (<div className="modbtn draft" title="Start/Restart Dispatch - the dispatch will be started and processed subject to stock availability." onClick={this.toggle.bind(this, 'draft')}>
              <i className="fa fa-stop" aria-hidden="true" />
            </div>)
      }
      else {
         draft = (<div className="modbtn live" title="Stop Dispatch - the dispatch will be stopped. The stock will be released, but can be restart later" onClick={this.toggle.bind(this, 'draft')}><i className="fa fa-play" aria-hidden="true" /></div>)
      }
      var hold;
      if(parseInt(detail.hold,0) || detail.hold ? 1 : 0){
          hold = (<div className="modbtn held" title="Release Dispatch (Currenty Held) - Allow dispatch to be processed." onClick={this.toggle.bind(this, 'hold')}>
              <i className="fa fa-pause" aria-hidden="true" />
            </div>)
      }
      else {
         hold = (<div className="modbtn hold" title="Hold Dispatch - the dispatch will be held until manually released, the stock will remain allocated to it." onClick={this.toggle.bind(this, 'hold')}><i className="fa fa-pause" aria-hidden="true" /></div>)
      }


      var refresh = (<div className="modbtn refresh" title="Retrieve up-to-date" onClick={this.retrieveDetail.bind(this, detail.id)}><i className="fa fa-refresh" aria-hidden="true" /></div>)
      if(this.isAdmin()){
        var cancel = (<div className="modbtn cancel" title="Cancel Dispatch" onClick={this.cancel}><i className="fa fa-ban" aria-hidden="true" /></div>)
      }
      else {
        var cancel = (<div className="modbtn cancel" title="Request Cancellation - Ask us to prevent this order from being dispatched." onClick={this.cancel}><i className="fa fa-ban" aria-hidden="true" /></div>)

      }
      var select_options;
      if(document.querySelectorAll('input:checked').length){
          var select_action;
          if(detail.dispatch_status >= 50){
            select_options =
             (<div>
              <button onClick={this.notifyReturn}>Notify Return</button>
             </div>)
          }
          else if (detail.dispatch_status < 30) {
            select_options =
             (<div>
              <button onClick={this.moveToNew}>Move to new Dispatch</button>
             </div>)
          }
      }
      var mgmt_button;
      if(this.isEditable()){
         mgmt_button  = (
           <div className="button_class">
            {draft}
            {hold}
            {sched}
            {prioritise}
            {refresh}
            {cancel}
            </div>
          )
      }
      var drawer_info;
      if(this.props.root.state.detail.delivery_instructions && this.props.root.state.detail.delivery_instructions.trim() || this.props.root.state.detail.notes && this.props.root.state.detail.notes.trim() || this.props.root.state.detail.gift_message && this.props.root.state.detail.gift_message.trim() ){
          drawer_info = <div className="info_mark">!</div>;
      }
      var fixedTop;
      var className = 'Dispatch';
      if(this.isEditable()){
        className += ' editable';
        fixedTop  = <div className="fixedTop">
                      <SearchBox showAllocated={true} parent={this} root={this.props.root}></SearchBox>
                      {active}
                    </div>
      }






        var dispatch_status;
        var status_class = "status";
        if(detail.dispatch_status >= 30){
            status_class += ' packed';

        }
        else if(detail.dispatch_status >= 10){
            status_class += ' active';
        }
        else {
            status_class += ' issue';
        }
        dispatch_status = <div className={status_class}>{FX.status('dispatches',this.props.root.state.detail.dispatch_status)}</div>

      var cancelPrompt;

      if(this.state.cancelPrompt){
         cancelPrompt = (
            <Modal type="confirm" buttons={[{text:'Cancel', className:'cancel', action:this.cancel.bind(this,false)},{className:'ok', text:'OK', action:this.cancel.bind(this,true)}]} >
               <p>We'll be notified that you want this dispatch cancelled.</p>
               <p>Because packing can happen at any time, we recommend contacting our Customer Services team to ensure that the dispatch is not processed.</p>
               <div className="title">Reason:</div>
               <textarea value={this.state.cancelPrompt.reason} onChange={this.handler.bind(this,'this.cancel')}></textarea>
            </Modal>
         )
      }

      var sideBar;
      if (this.state.showSide) {
      
        var export_options;
        if (this.props.root.state.detail.delivery_address.country_code != "GB" || "BT" === FX.postcodeFormat(this.props.root.state.detail.delivery_address.postcode, this.props.root.state.detail.delivery_address.country_code).substr(0,2)){
            export_options = (<div className="export_options">
                <h4>Export Options</h4>
                <div>
                <label class="label">Export Terms</label>
                <select disabled>
                    <option>DAP: Delivered At Place</option>
                </select>
                </div>
                <div>
                <label class="label">Export Reason</label>
                <select disabled>
                    <option>Sale of Goods</option>
                </select>
                </div>
            </div>);
        } 
        sideBar = (
          <div id="SideBar">
            <div className="reference">{this.props.root.state.detail.reference}<span>{this.props.root.state.detail.id}</span></div>
            {dispatch_status}
            {release_date}
            {mgmt_button}
            {calendar}
            {post_services}
            {dispatch_date}
            <AddressViewer fs={true}  onClick={()=>{if(this.isEditable()){console.log('p'); this.editAddress('delivery');}}} title="Delivery Address" address={this.props.root.state.detail.delivery_address} root={this.props.root} varTgt="delivery_address"/>
            <div className="tidy" />
            {export_options}
            <ConsignmentViewer fs={true}  onClick={()=>{if(this.isEditable()){console.log('p'); this.editAddress('delivery');}}} consignment={this.props.root.state.detail.consignment} address={this.props.root.state.detail.delivery_address} root={this.props.root} varTgt="consignment"/>
            {admin_controls}
            {sideButtons}
          </div>
        )
      }
      var toggleSide;
      if ( this.state.showSide ) {
         toggleSide = (<div className="toggleSide" onClick={this.toggleSide}>View Make Up</div>);
      }
      else {
         toggleSide = (<div className="toggleSide" onClick={this.toggleSide}>View Details</div>);
      }
      return (
        <div className={className}>
          {toggleSide}
          {fixedTop}
          {cancelPrompt}

          <div className="order_connect">
              <div className="label">Order</div>
              <div className='orderLink' onMouseUp={(e)=>{console.log(e); if(e.button == 1){ window.open('/orders/'+this.props.root.state.detail.order_id);}}} onClick={FX.navigate.bind(this.props.root, 'orders'  , this.props.root.state.detail.order_id ,'/orders/'+this.props.root.state.detail.order_id)} >
                  <i className="fa fa-file-text-o" aria-hidden="true" /> {this.props.root.state.detail.order.reference}
              </div>
          </div>


          <div>
            {this.props.root.state.detail.status}
          </div>
          <div className="warn">
              {warn}
          </div>
          <div>
            <table className="itemList">
              {dispatch_headers}
              {dispatch_items}
            </table>
            {select_options}
          </div>

          <ContextMenu root={this.props.root} options={this.state.context.options}  location={this.state.context.location} parent={this} show={this.state.context.show} />


          {editAddress}
          {moveToNewDispatch}
          <div id="Drawer" className={this.state.drawerState}>
            <div className="drawer_title" onClick={this.toggleDrawer}>Notes & Messages{drawer_info}</div>
            <div className="labels">
                <label for="ta_delivery_instructions">Delivery Instructions</label>
                <label for="ta_notes">Notes</label>
                <label for="ta_gift_message">Gift Message</label>
            </div>
            <div className="options">
                <textarea id="ta_delivery_instructions" placeholder="Delivery Instructions" value={this.props.root.state.detail.delivery_instructions} onChange={this.handler.bind(this, 'delivery_instructions')} />
                <textarea id="ta_notes" placeholder="Notes" value={this.props.root.state.detail.notes} onChange={this.handler.bind(this, 'notes')} />
                <textarea id="ta_gift_message" placeholder="Gift Message" value={this.props.root.state.detail.gift_message}  onChange={this.handler.bind(this, 'gift_message')} />
            </div>
          </div>
          {sideBar}
        </div>
      );
    }

          /*
          <button onClick={() => this.props.root.setState({ show: true })}>Alert</button>
          <button onClick={this.contextShow}>Alert</button>
          */
    else if (detail) {
       return (<div className="Dispatch loading">
          <div>Loading</div>
        </div>)
    }
    else {
      var multiOption;
      var mergeConfirm;
      var checked;
      var check = this.state.checked;
      if(Array.isArray(check) && check.length === 1){
          multiOption = (<div id="mergePrompt">
            Please select more dispatches to merge.
          </div>)
      }
      else if(Array.isArray(check) && check.length > 1){
          var mergeTo = [];
          checked = check.map(disp => {
              var disp_items = disp.dispatch_items.map(disp_it => {
                  return (<div className="dispatchItems">{disp_it.product.sku}: {disp_it.product.name} {disp_it.product.qty}</div>)
              })

              mergeTo.push(<option value={disp.id}>{disp.reference}: {disp.delivery_address.forename} {disp.delivery_address.surname}</option>)

              return (<div className="dispatches">
                        {disp.reference}: {disp.delivery_address.forename} {disp.delivery_address.surname}
                        {disp_items}
              </div>);
          })

          multiOption = (<div id="multiOption">
            <div><button onClick={this.mergeDispatches}>Merge Dispatches</button></div>
            {multiOption}
          </div>)

          if(this.state.mergeConfirm){
            mergeConfirm = (
              <Modal close={this.closeModal} title="Merge Dispatches" buttons={[{text:'Merge',action:this.merge}]}>
                <div className="mergeConfirm">

                    <div className="mergeTo">
                        <label for="mergTo">Merge All Into:</label>
                        <select id="mergeTo">
                          {mergeTo}
                        </select>
                    </div>
                    {checked}
                </div>
              </Modal>
            )
          }
      }
      var dispatches = [];
      if(this.props.root.state.current_customer.dispatches){
        dispatches = this.props.root.state.current_customer.dispatches;
      }
      var lookup_box = [];
      if(this.props.all_customers){
        lookup_box = <input className="lookup_box" />
      }
      return (
        <div className="Dispatches">
          {multiOption}
          {mergeConfirm}
          {lookup_box}
            <div className="controls" />
          <List id="dispatches" showState={true} selectable={true} root={this.props.root} checkAction={this.dispatchCheck} clickAction={Config.tables.dispatches.click} display={{object:"dispatch", items:dispatches}} model={Config.tables.dispatches} setPage={this.setPage} />
        </div>
      );
    }
  }
}

export default Dispatch;



// WEBPACK FOOTER //
// ./src/Dispatch.js